export default __webpack_public_path__ + "static/media/logo-white.fc658a1b.svg";